import { createFileRoute } from "@tanstack/react-router";

import { AdminKakekomiEditPage } from "@/features/admin/kakekomi/kakekomi-edit-page";
import { adminKakekomiEventQueryOptions } from "@/features/admin/kakekomi/queries";

// ロールガードは親 layout (`admin/route.tsx`) が ADMIN 限定。
export const Route = createFileRoute("/_authenticated/admin/kakekomi/$id/edit")({
  staticData: { crumb: { label: "編集" } },
  loader: ({ context, params }) =>
    context.queryClient.ensureQueryData(adminKakekomiEventQueryOptions(params.id)),
  component: function Page() {
    const { id } = Route.useParams();
    return <AdminKakekomiEditPage id={id} />;
  },
});
